import { render, staticRenderFns } from "./ConfigStatus.vue?vue&type=template&id=63fc2484&scoped=true"
import script from "./ConfigStatus.vue?vue&type=script&lang=js"
export * from "./ConfigStatus.vue?vue&type=script&lang=js"
import style0 from "./ConfigStatus.vue?vue&type=style&index=0&id=63fc2484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc2484",
  null
  
)

export default component.exports